module.exports = __webpack_public_path__ + "static/media/time@3x.5ca648d8.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/time@3x.png
// module id = 676
// module chunks = 0